'use client'
import DonationFormRequiredField from '@/donationPages/_dependencies/components/DonationFormRequiredField'
import FormInput from '@/form/FormInput'
import { useDonationFormValues } from '@/donationPages/_dependencies/helpers'
import { useTranslations } from 'next-intl'

function CompanyFields() {
  const t = useTranslations('nextjs.donate.attributes')
  const [companyDonation] = useDonationFormValues(['_company_donation'])
  if (!companyDonation) return null

  return <DonationFormRequiredField name="company_name" title={t('company_name')} as={FormInput} />
}

export default CompanyFields
